import { Alert, Snackbar } from "@mui/material";
import React from "react";

const BaseSnackbar = ({ open, handleClose, type, timer, message }) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      autoHideDuration={timer || 6000}
      onClose={handleClose}
      sx={{
        '& *': {
            fontSize: "120% !important"
        }
      }}
    >
      <Alert
        onClose={handleClose}
        severity={type || "success"}
        icon={false}
        sx={{ width: "100%", fontSize: "14px !important" }}
      >
        {message || "This is a success message!"}
      </Alert>
    </Snackbar>
  );
};

export default BaseSnackbar;
